function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.975 21.172A15.584 15.584 0 0018.159 17h2.488a10.052 10.052 0 01-4.672 4.172zM3.353 17H5.84a15.543 15.543 0 002.18 4.169 10.051 10.051 0 01-4.667-4.17zM8.026 2.828A15.556 15.556 0 005.842 7h-2.49a10.064 10.064 0 014.674-4.172zM20.646 7H18.16a15.598 15.598 0 00-2.183-4.17A10.048 10.048 0 0120.647 7zm-1.954 2h2.847a9.95 9.95 0 01.46 3 9.95 9.95 0 01-.46 3H18.69c.196-.982.309-1.984.309-3s-.113-2.017-.308-3zM13 15V9h3.653c.225.977.347 1.982.347 3a13.35 13.35 0 01-.347 3H13zm0 6.55V17h3.012A13.583 13.583 0 0113 21.55zM11 17v4.555A13.577 13.577 0 017.987 17H11zm0-14.55V7H7.989a13.582 13.582 0 013.01-4.55zM16.013 7H13V2.447A13.623 13.623 0 0116.013 7zM7 12.002c0-1.02.123-2.024.348-3.002H11v6H7.347A13.34 13.34 0 017 12.002zM2 12a9.98 9.98 0 01.46-3H5.31a15.412 15.412 0 00-.31 3.002c0 1.016.115 2.018.309 2.998H2.462A9.95 9.95 0 012 12zM12 0C5.384 0 0 5.383 0 12s5.384 12 12 12c6.617 0 12-5.383 12-12S18.617 0 12 0z"
});

var SvgIconInternet = function SvgIconInternet(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconInternet;